import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";
var _dec, _class, _class2, _descriptor, _ColumnDropZone;
/*
 *                     NOTICE
 *            COPYRIGHT 2024 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { ReactUtils } from "abreact/incubator/ui/utils/ReactUtils";
import { LogUtils } from "abweb/utils/log/LogUtils";
import { action, makeObservable, observable, runInAction } from "mobx";
import { observer } from "mobx-react";
import * as React from "react";
export let ColumnDropZone = (_dec = action.bound, observer(_class = (_class2 = (_ColumnDropZone = class ColumnDropZone extends React.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "divRootRef", void 0);
    _defineProperty(this, "_clientBoundingRect", void 0);
    _initializerDefineProperty(this, "dropAreaPosition", _descriptor, this);
    _defineProperty(this, "columnExclusionSet", void 0);
    _defineProperty(this, "autoScrollDirection", AutoScrollDirection.None);
    _defineProperty(this, "autoScrollTimerId", 0);
    this.divRootRef = /*#__PURE__*/React.createRef();
    this.columnExclusionSet = this.initializeColumnExclusionSet(props);
    this.onDragOver = this.onDragOver.bind(this);
    this.onDrop = this.onDrop.bind(this);
    makeObservable(this);
  }
  initializeColumnExclusionSet(props) {
    let info = new Set(props.columnDragList);
    return info;
  }
  render() {
    let {
      dataGrid,
      leftOffset,
      containerHeight
    } = this.props;
    let styles = {
      left: leftOffset,
      width: dataGrid.scrollParams.clientWidth,
      height: containerHeight
    };
    return /*#__PURE__*/React.createElement("div", {
      className: "data-grid-column-drop-zone",
      style: styles,
      ref: this.divRootRef,
      onDragOver: this.onDragOver,
      onDrop: this.onDrop,
      onDragLeave: this.onDragLeave
    }, this.renderDropArea());
  }
  componentWillUnmount() {
    this.clearAutoScrollTimer();
  }
  renderDropArea() {
    if (this.dropAreaPosition < 0) {
      return null;
    }
    let scrollContainerStyles = {
      left: this.dropAreaPosition - 5
    };
    return /*#__PURE__*/React.createElement(DropAreaBracket, {
      style: scrollContainerStyles
    });
  }
  onDragLeave(event) {
    // ColumnDropZone.LOGGER.info(`onDragLeave clientX: ${event.clientX} clientY: ${event.clientY}`);
    this.dropAreaPosition = -1;
  }
  onDragOver(event) {
    event.preventDefault();

    // It seems that you cannot use dataTransfer.getData() in a dragover event handler
    // let dragSource = event.dataTransfer.getData("dataGridColumnMove");

    let xLocal = event.clientX - this.clientBoundingRect.left;
    let colInfo = this.hitTest(xLocal);
    let position = colInfo ? colInfo.xRight : -1;

    // ColumnDropZone.LOGGER.info(`onDragOver clientX: ${event.clientX} clientY: ${event.clientY} dropAreaPosition: ${position}`);

    if (this.dropAreaPosition !== position) {
      // ColumnDropZone.LOGGER.info(`onDragOver clientX: ${event.clientX} clientY: ${event.clientY} dropAreaPosition: ${position}`);
      runInAction(() => this.dropAreaPosition = position);
    }
    event.dataTransfer.dropEffect = "move";
    // event.dataTransfer.dropEffect = (position < 0) ? "none" : "move";

    if (xLocal <= 20) {
      this.setAutoScrollDirection(AutoScrollDirection.Left);
    } else if (xLocal >= this.clientBoundingRect.width - 20) {
      this.setAutoScrollDirection(AutoScrollDirection.Right);
    } else {
      this.setAutoScrollDirection(AutoScrollDirection.None);
    }
  }
  onDrop(event) {
    event.preventDefault();
    let dragSource = event.dataTransfer.getData("dataGridColumnMove");
    let xLocal = event.clientX - this.clientBoundingRect.left;
    let colInfo = this.hitTest(xLocal);
    if (colInfo == null) {
      ColumnDropZone.LOGGER.info(`onDrop dragSource: ${dragSource} drop is not valid`);
    } else {
      ColumnDropZone.LOGGER.info(`onDrop dragSource: ${dragSource} Drop on parentCol: ${colInfo.parentColumn?.id} insertColumnBefore: ${colInfo.insertColumnBefore?.id}`);
      this.props.onDrop(this.props.columnDragList, colInfo.insertColumnBefore);
    }
  }
  get clientBoundingRect() {
    if (this._clientBoundingRect == null) {
      this._clientBoundingRect = this.divRootRef.current.getBoundingClientRect();
      ColumnDropZone.LOGGER.debug(`clientBoundingRect left: ${this._clientBoundingRect.left} top: ${this._clientBoundingRect.top}`);
    }
    return this._clientBoundingRect;
  }
  hitTest(xLocal) {
    let {
      dataGrid,
      currentColumns
    } = this.props;
    const affordance = 10;

    // Adjust for the grid's scroll pos
    let xRight = -dataGrid.scrollParams.scrollLeft;

    // We can assume that all columns in our drag list have the same parent
    let parentColumn = this.props.columnDragList[0].parentColumn;
    let visibleColumns = parentColumn ? parentColumn.getVisibleChildColumns() : currentColumns.filter(col => col.visible && !dataGrid.isColumnFrozen(col));
    if (parentColumn) {
      // Need to adjust xRight to be left edge of first column in visibleColumns
      for (let col of dataGrid.visibleLeafColumns.filter(col => !dataGrid.isColumnFrozen(col))) {
        if (col === visibleColumns[0]) {
          // We are done
          break;
        }
        xRight += col.actualWidth;
      }
    }

    // Check for left of first visible column
    if (xLocal >= xRight && xLocal <= xRight + affordance && !this.columnExclusionSet.has(visibleColumns[0])) {
      let col = visibleColumns[0];
      return {
        parentColumn: col.parentColumn,
        insertColumnBefore: visibleColumns[0],
        xRight
      };
    }
    for (let index = 0; index < visibleColumns.length; index++) {
      // Test right edges of all visibleColumns
      let col = visibleColumns[index];
      xRight += col.actualWidth;
      if (this.columnExclusionSet.has(col)) {
        // Can't drop here
        continue;
      }
      if (index < visibleColumns.length - 1) {
        // We have a column to the right, so it can't be in the exclusion list either
        if (this.columnExclusionSet.has(visibleColumns[index + 1])) {
          continue;
        }
      }
      if (xLocal >= xRight - affordance && xLocal <= xRight + affordance) {
        return {
          parentColumn: parentColumn,
          insertColumnBefore: index < visibleColumns.length - 1 ? visibleColumns[index + 1] : null,
          xRight
        };
      }
    }
    return null;
  }
  setAutoScrollDirection(direction) {
    if (direction === this.autoScrollDirection) {
      // No change
      return;
    }
    let {
      dataGrid
    } = this.props;
    if (direction === AutoScrollDirection.None) {
      this.clearAutoScrollTimer();
    } else if (direction === AutoScrollDirection.Left) {
      if (dataGrid.scrollParams.scrollLeft === 0) {
        // Already at the far left
        return;
      }
    } else if (direction === AutoScrollDirection.Right) {
      if (dataGrid.scrollParams.scrollLeft === this.maxScrollPos) {
        // Already at the far right
        return;
      }
    }
    this.autoScrollDirection = direction;
    this.clearAutoScrollTimer();
    this.autoScrollTimerId = setInterval(() => this.autoScrollTimerHandler(), 200);
  }
  autoScrollTimerHandler() {
    if (this.autoScrollDirection === AutoScrollDirection.None) {
      return;
    }
    const scrollIncrement = 40;
    let {
      dataGrid
    } = this.props;
    if (this.autoScrollDirection === AutoScrollDirection.Left) {
      // We want to decrease the value of the grid's scrollLeft
      let newValue = Math.max(0, dataGrid.scrollParams.scrollLeft - scrollIncrement);
      if (newValue === 0) {
        this.clearAutoScrollTimer();
      }
      dataGrid.scrollToPosition({
        scrollLeft: newValue
      });

      // Not sure if this the right thing to do
      runInAction(() => this.dropAreaPosition = -1);
    } else {
      // We are at right side so we want to increase the grid's scrollLeft
      let maxValue = this.maxScrollPos;
      let newValue = Math.min(dataGrid.scrollParams.scrollLeft + scrollIncrement, maxValue);
      if (newValue === maxValue) {
        this.clearAutoScrollTimer();
      }
      dataGrid.scrollToPosition({
        scrollLeft: newValue
      });

      // Not sure if this the right thing to do
      runInAction(() => this.dropAreaPosition = -1);
    }
  }
  get maxScrollPos() {
    let {
      dataGrid
    } = this.props;
    if (dataGrid.scrollParams.scrollWidth <= dataGrid.scrollParams.clientWidth) {
      // Note there could be some fractional pixel roundoff error so we do not use === test
      return 0;
    }
    return dataGrid.scrollParams.scrollWidth - dataGrid.scrollParams.clientWidth + dataGrid.verticalScrollBarSize;
  }
  clearAutoScrollTimer() {
    if (this.autoScrollTimerId !== 0) {
      clearInterval(this.autoScrollTimerId);
      this.autoScrollTimerId = 0;
    }
  }
}, _defineProperty(_ColumnDropZone, "LOGGER", LogUtils.getLogger(__filename)), _ColumnDropZone), _descriptor = _applyDecoratedDescriptor(_class2.prototype, "dropAreaPosition", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return -1;
  }
}), _applyDecoratedDescriptor(_class2.prototype, "onDragLeave", [_dec], Object.getOwnPropertyDescriptor(_class2.prototype, "onDragLeave"), _class2.prototype), _class2)) || _class);
const DropAreaBracket = props => {
  const commonProps = ReactUtils.componentProps("drop-area-bracket", props);
  return /*#__PURE__*/React.createElement("div", commonProps, /*#__PURE__*/React.createElement("div", {
    className: "drop-area-bracket-head"
  }), /*#__PURE__*/React.createElement("div", {
    className: "drop-area-bracket-body"
  }), /*#__PURE__*/React.createElement("div", {
    className: "drop-area-bracket-tail"
  }));
};
var AutoScrollDirection = /*#__PURE__*/function (AutoScrollDirection) {
  AutoScrollDirection["None"] = "None";
  AutoScrollDirection["Left"] = "Left";
  AutoScrollDirection["Right"] = "Right";
  return AutoScrollDirection;
}(AutoScrollDirection || {});
//# sourceMappingURL=ColumnDropZone.js.map
